import { render } from "./icon-database.vue?vue&type=template&id=f7ed5f34"
import script from "./icon-database.vue?vue&type=script&lang=js"
export * from "./icon-database.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__